// extracted by mini-css-extract-plugin
module.exports = {"root":"FloatActionsBlock_root__3vnDU","actionBtn":"FloatActionsBlock_actionBtn__1GCu-"};